export class DeleteUserRequest {  

    public id_Usuario : number=0;
    
    }